import React, { useState } from 'react';
import styled from 'styled-components';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaWhatsapp } from 'react-icons/fa';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';

// Styled Components
const ContactSection = styled.section`
  padding: 5rem 0;
  background-color: #f8fafc;
`;

const SectionTitle = styled.h2`
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 3rem;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -15px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 3px;
    background-color: #f59e0b;
  }
`;

const ContactContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 3rem;
`;

const ContactInfo = styled.div`
  background-color: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
`;

const ContactForm = styled.form`
  background-color: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
`;

const InfoTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  color: #1f2937;
`;

const InfoItem = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 1.5rem;
`;

const IconWrapper = styled.div`
  font-size: 1.25rem;
  color: #1e3a8a;
  margin-right: 1rem;
  min-width: 24px;
  margin-top: 3px;
`;

const InfoContent = styled.div`
  color: #4b5563;
  
  p {
    margin: 0;
    line-height: 1.6;
  }
`;

const MapWrapper = styled.div`
  margin-top: 2rem;
  border-radius: 12px;
  overflow: hidden;
  height: 300px;
  
  iframe {
    width: 100%;
    height: 100%;
    border: 0;
  }
`;

// const LocationCard = styled.a`
//   display: flex;
//   align-items: center;
//   gap: 1rem;
//   padding: 1rem;
//   margin-top: 1rem;
//   background: linear-gradient(135deg, #3b82f6, #2563eb);
//   color: white;
//   border-radius: 12px;
//   text-decoration: none;
//   transition: all 0.3s ease;
//   cursor: pointer;
  
//   &:hover {
//     transform: translateY(-2px);
//     box-shadow: 0 8px 25px rgba(37, 99, 235, 0.3);
//     background: linear-gradient(135deg, #2563eb, #1d4ed8);
//   }
  
//   &:active {
//     transform: translateY(0);
//   }
// `;

// const LocationIcon = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   width: 50px;
//   height: 50px;
//   background: rgba(255, 255, 255, 0.2);
//   border-radius: 50%;
//   font-size: 1.5rem;
// `;

// const LocationText = styled.div`
//   flex: 1;
  
//   h4 {
//     margin: 0 0 0.25rem 0;
//     font-size: 1.1rem;
//     font-weight: 600;
//   }
  
//   p {
//     margin: 0;
//     font-size: 0.9rem;
//     opacity: 0.9;
//   }
// `;

const FormGroup = styled.div`
  margin-bottom: 1.5rem;
`;

const Label = styled.label`
  display: block;
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: #1f2937;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 1rem;
  transition: all 0.3s ease;
  
  &:focus {
    outline: none;
    border-color: #1e3a8a;
    box-shadow: 0 0 0 3px rgba(30, 58, 138, 0.1);
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 1rem;
  transition: all 0.3s ease;
  min-height: 150px;
  resize: vertical;
  
  &:focus {
    outline: none;
    border-color: #1e3a8a;
    box-shadow: 0 0 0 3px rgba(30, 58, 138, 0.1);
  }
`;

const SubmitButton = styled.button`
  background-color: #1e3a8a;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-weight: 600;
  font-size: 1rem;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  
  &:hover {
    background-color: #1e40af;
    transform: translateY(-2px);
  }
  
  &:disabled {
    background-color: #9ca3af;
    cursor: not-allowed;
    transform: none;
  }
`;

const ThankYouMessage = styled.div`
  text-align: center;
  padding: 2rem;
  background-color: #ecfdf5;
  border-radius: 8px;
  border: 1px solid #10b981;
  
  h3 {
    color: #10b981;
    margin-bottom: 1rem;
  }
  
  p {
    color: #1f2937;
  }
`;

const ErrorMessage = styled.div`
  color: #ef4444;
  font-size: 0.875rem;
  margin-top: 0.5rem;
`;

const WhatsAppButton = styled.a`
  position: fixed;
  bottom: 30px;
  right: 30px;
  background-color: #25d366;
  color: white;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.75rem;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  z-index: 999;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.25);
  }
`;

const Contact = () => {
  // Form state
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  
  // Form submission state
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');
  
  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    
    try {
      // Add message to Firestore
      await addDoc(collection(db, 'contactMessages'), {
        ...formData,
        createdAt: new Date().toISOString()
      });
      
      // Show success message
      setIsSubmitted(true);
      
      // Reset form
      setFormData({
        name: '',
        email: '',
        message: ''
      });
    } catch (err) {
      console.error('Error sending message: ', err);
      setError('There was an error sending your message. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };
  
  return (
    <ContactSection id="contact">
      <SectionTitle>Contact Us</SectionTitle>
      <ContactContainer>
        <ContactInfo>
          <InfoTitle>Get In Touch</InfoTitle>
          
          <InfoItem>
            <IconWrapper>
              <FaMapMarkerAlt />
            </IconWrapper>
            <InfoContent>
              <p>Sangritop, Watlab Sopore</p>
              <p> Jammu and Kashmir - 193201</p>
            </InfoContent>
          </InfoItem>
          
          {/* <LocationCard 
            href="https://www.google.com/maps/place/WULAR+WATER+FRONT+RESORT/@34.3750294,74.5158635,17z/data=!4m7!3m6!1s0x38e10d0037bca5ed:0xa97dacf2aca434f6!4b1!8m2!3d34.3750294!4d74.5184384!16s%2Fg%2F11x2stdcb1?entry=ttu&g_ep=EgoyMDI2MDIyNS4wIKXMDSoASAFQAw%3D%3D"
            target="_blank"
            rel="noopener noreferrer"
          >
            <LocationIcon>
              📍
            </LocationIcon>
            <LocationText>
              <h4>Get Directions</h4>
              <p>Click to navigate to our resort on Google Maps</p>
            </LocationText>
          </LocationCard> */}
          
          <InfoItem>
            <IconWrapper>
              <FaPhone />
            </IconWrapper>
            <InfoContent>
              <p>+91 6005697823</p>
              
            </InfoContent>
          </InfoItem>
          
          <InfoItem>
            <IconWrapper>
              <FaEnvelope />
            </IconWrapper>
            <InfoContent>
              <p>wularwaterfrontresort@gmail.com</p>
            </InfoContent>
          </InfoItem>
          
          <MapWrapper>
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26563.893746336188!2d74.62442999999999!3d34.25714!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38e10d0037bca5ed:0xa97dacf2aca434f6!2sWULAR+WATER+FRONT+RESORT!5e0!3m2!1sen!2sin!4v1690892234757!5m2!1sen!2sin" 
              title="Wular Water Front Resort Location"
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade">
            </iframe>
          </MapWrapper>
        </ContactInfo>
        
        <ContactForm onSubmit={handleSubmit}>
          {isSubmitted ? (
            <ThankYouMessage>
              <h3>Thank You!</h3>
              <p>Your message has been sent successfully.</p>
              <p>We will get back to you as soon as possible.</p>
            </ThankYouMessage>
          ) : (
            <>
              <InfoTitle>Send Us a Message</InfoTitle>
              
              <FormGroup>
                <Label htmlFor="name">Your Name</Label>
                <Input 
                  type="text" 
                  id="name" 
                  name="name" 
                  value={formData.name} 
                  onChange={handleInputChange}
                  placeholder="Enter your name"
                  required
                />
              </FormGroup>
              
              <FormGroup>
                <Label htmlFor="email">Your Email</Label>
                <Input 
                  type="email" 
                  id="email" 
                  name="email" 
                  value={formData.email} 
                  onChange={handleInputChange}
                  placeholder="Enter your email address"
                  required
                />
              </FormGroup>
              
              <FormGroup>
                <Label htmlFor="message">Your Message</Label>
                <TextArea 
                  id="message" 
                  name="message" 
                  value={formData.message} 
                  onChange={handleInputChange}
                  placeholder="Enter your message"
                  required
                />
              </FormGroup>
              
              {error && <ErrorMessage>{error}</ErrorMessage>}
              
              <SubmitButton type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </SubmitButton>
            </>
          )}
        </ContactForm>
      </ContactContainer>
      
      {/* WhatsApp Button */}
      <WhatsAppButton 
        href="https://wa.me/919876543210" 
        target="_blank" 
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp />
      </WhatsAppButton>
    </ContactSection>
  );
};

export default Contact;
